import { Injectable } from '@angular/core';
import { SchemaTypes } from './rich-results.values';

@Injectable()
export abstract class RichResultsService {
  abstract setJsonLd(type: SchemaTypes, data: unknown): void;

  abstract setTrustpilotRatesJsonLd(nameWebSite: string): void;
}
